<div class="ledger">
  <section class="ledger-card">
    <h2 class="section-title">
      {{ 'app.patrol.discord.cockpit.ledger.title' | translate }}
    </h2>
    <p class="section-hint">
      {{ 'app.patrol.discord.cockpit.ledger.hint' | translate }}
    </p>

    <form class="filter-form" (ngSubmit)="applyFilter()">
      <label class="filter-field">
        <span class="filter-field__label">
          {{ 'app.patrol.discord.cockpit.ledger.userFilterLabel' | translate }}
        </span>
        <input
          type="text"
          class="filter-field__input"
          [ngModel]="userFilter()"
          (ngModelChange)="onUserFilterChange($event)"
          name="discordUserId"
          autocomplete="off"
          [placeholder]="
            'app.patrol.discord.cockpit.ledger.userFilterPlaceholder' | translate
          "
        />
      </label>
      <button type="submit" class="filter-form__btn" [disabled]="isLoading()">
        {{ 'app.patrol.discord.cockpit.ledger.applyFilter' | translate }}
      </button>
    </form>
  </section>

  @if (isLoading() && ledgerItems().length === 0) {
    <p class="ledger__hint">
      {{ 'app.patrol.discord.cockpit.ledger.loading' | translate }}
    </p>
  } @else if (loadError() === 'load_failed') {
    <p class="ledger__error" role="alert">
      {{ 'app.patrol.discord.cockpit.ledger.loadError' | translate }}
    </p>
  } @else if (ledgerItems().length > 0) {
    <section class="ledger-card">
      <div class="table-wrap">
        <table class="ledger-table">
          <thead>
            <tr>
              <th>{{ 'app.patrol.discord.cockpit.ledger.colCase' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.ledger.colTime' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.ledger.colMember' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.ledger.colChannel' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.ledger.colAction' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.ledger.colViolation' | translate }}</th>
              <th>{{ 'app.patrol.discord.cockpit.ledger.colReputation' | translate }}</th>
            </tr>
          </thead>
          <tbody>
            @for (item of ledgerItems(); track item.caseId) {
              <tr>
                <td>
                  <button
                    type="button"
                    class="case-link"
                    (click)="openCase(item.caseId)"
                  >
                    <code>{{ shortCaseId(item.caseId) }}</code>
                  </button>
                </td>
                <td>{{ formatDate(item.occurredAt) }}</td>
                <td>
                  @if (item.platformUserId) {
                    <code>{{ item.platformUserId }}</code>
                  } @else {
                    —
                  }
                </td>
                <td>{{ item.channelName ?? '—' }}</td>
                <td>
                  <span class="action-badge" [attr.data-action]="item.primaryAction">
                    {{ actionLabel(item.primaryAction) | translate }}
                  </span>
                </td>
                <td>
                  @if (item.violationType) {
                    {{ item.violationType }} ({{ item.severity ?? '—' }})
                  } @else {
                    —
                  }
                </td>
                <td>
                  @if (item.reputationDelta != null) {
                    <span
                      [class.rep-delta--neg]="item.reputationDelta < 0"
                      [class.rep-delta--pos]="item.reputationDelta > 0"
                    >
                      @if (item.reputationDelta > 0) {
                        +{{ item.reputationDelta }}
                      } @else {
                        {{ item.reputationDelta }}
                      }
                    </span>
                  } @else {
                    —
                  }
                </td>
              </tr>
            }
          </tbody>
        </table>
      </div>

      @if (nextBefore()) {
        <div class="load-more">
          <button
            type="button"
            class="load-more__btn"
            [disabled]="isLoading()"
            (click)="loadMore()"
          >
            {{ 'app.patrol.discord.cockpit.ledger.loadMore' | translate }}
          </button>
        </div>
      }
    </section>
  } @else if (!isLoading()) {
    <p class="empty-hint">
      {{ 'app.patrol.discord.cockpit.ledger.empty' | translate }}
    </p>
  }

  <p class="privacy-note">
    {{ 'app.patrol.discord.cockpit.ledger.privacyNote' | translate }}
  </p>
</div>
